import { deviceTypes } from '@styles/mediaQueries';
import { zIndexes } from '@styles/zindex/zindex';
import DetectableOverflow from 'react-detectable-overflow';
import styled, { css } from 'styled-components';
import { getHeadingHeight, IHeadingHeightContainer } from './getHeadingHeight';

export const SidebarHeading = styled.div`
  position: sticky;
  top: 0;
  // Todo: Update to better z-index based on response
  z-index: ${zIndexes.indexOf('table-scrollbar')};
  background-color: white;
  padding-top: 24px;

  [data-device='${deviceTypes.mobile}'] & {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
  }
`;
export const AssetSidebarContainer = styled.div<IHeadingHeightContainer>`
  height: 100%;
  max-height: 100%;
  overflow: auto;
  scroll-behavior: smooth;

  overflow-x: hidden;
  background: #fff;
  border-right: 1px solid #e6e8f0;
  padding: 0 24px 24px;

  --sidebar-heading-height: ${getHeadingHeight}px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  [data-device='${deviceTypes.mobile}'] & {
    overflow: visible;
    padding-top: calc(var(--sidebar-heading-height));
  }
  &.loading {
    padding-top: 24px;
    [data-device='${deviceTypes.mobile}'] & {
      height: var(--100vh);
      height: 100dvh;
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #c1c4d6;
  margin-left: 9px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Icon = styled.div`
  height: 20px;
  overflow: hidden;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Product = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 16px;
`;
interface IProductName {
  limitOfLines?: number;
}

export const ProductName = styled(DetectableOverflow)<IProductName>`
  margin-left: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const ProductImage = styled.div`
  border-radius: 4px;
  border: 1px solid #e6e8f0;
  padding: 4px;
  height: 64px;
  width: 64px;
  min-width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductImg = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const TemporaryImg = styled.div`
  height: 20px;
`;

export const ProductImgEmpty = styled.div`
  height: 30px;
`;

export const Temporary = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const TemporaryText = styled.div`
  margin-left: 8px;
  color: #ff9900;
  font-size: 14px;
  font-weight: 500;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e6e8f0;
  margin-top: 16px;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const SidebarGroup = styled.div`
  padding-top: 11px; // 5 extra px from button padding
  padding-bottom: 24px;
  border-bottom: 1px solid var(--beam-color-neutral-n300);

  &.last {
    border-bottom: none;
  }
`;
export const LineText = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
`;

export const Button = styled.button``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  align-self: flex-end;
`;

interface IIdentificationText {
  clickable?: boolean;
}

export const IdentificationText = styled.div<IIdentificationText>`
  font-size: 14px;
  font-weight: 400;
  color: #696f8c;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

  &.tooltip {
    font-weight: 500;
    font-size: 12px;
    color: #fff;
  }

  &.tooltipSubtext {
    font-size: 12px;
    font-weight: 300;
    color: #fff;

    text-align: left;
  }
`;

export const IdentificationIcon = styled.div`
  height: 24px;
`;

export const IconsWrapper = styled.div`
  height: 21px;
`;

interface ITooltipDiv {
  clickable?: boolean;
}

export const TooltipDiv = styled.div<ITooltipDiv>`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

export const TooltipWraper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;
